import React from 'react';

const Card = ({
  children,
  className = '',
  padding = 'normal',
  shadow = true,
  ...props
}) => {
  const baseClasses = 'bg-white rounded-2xl border border-slate-100 transition-all duration-300';

  const paddingClasses = {
    none: '',
    small: 'p-4',
    normal: 'p-6',
    large: 'p-8'
  };

  const shadowClass = shadow ? 'shadow-soft hover:shadow-md hover:border-slate-200' : '';
  const paddingClass = typeof padding === 'string' ? paddingClasses[padding] : (padding ? 'p-6' : '');

  return (
    <div
      className={`${baseClasses} ${paddingClass} ${shadowClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({
  title,
  subtitle,
  action,
  children,
  className = '',
  ...props
}) => {
  return (
    <div className={`flex justify-between items-start pb-4 border-b border-gray-200 ${className}`} {...props}>
      <div className="flex-1">
        {title && (
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        )}
        {subtitle && (
          <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
        )}
        {children}
      </div>
      {action && (
        <div className="flex-shrink-0 ml-4">
          {action}
        </div>
      )}
    </div>
  );
};

const CardBody = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <div className={`py-4 ${className}`} {...props}>
      {children}
    </div>
  );
};

const CardFooter = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <div className={`pt-4 border-t border-gray-200 ${className}`} {...props}>
      {children}
    </div>
  );
};

export default Card;
export { CardHeader, CardBody, CardFooter };